<script setup lang="ts">
defineProps<{ text: string }>();
</script>

<template>
  <div class="empty flex flex-col items-center gap-4" role="status">
    <i class="spinner spinner--lg text-brand-600" aria-hidden="true" />
    <span>{{ text }}</span>
  </div>
</template>
